import { Suspense, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as AddressBookModule from "@/redux/modules/api/data/addressbook/addressbook.module";
import {
    getAddresses,
    isLoading
} from "@/redux/modules/api/data/addressbook/addressbook.selectors";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import ProfileAddresses from "./addresses.component";

type ProfileAddressesContainerProps = { linkAddressBook: string };

const ProfileAddressesContainer = ({
    linkAddressBook
}: ProfileAddressesContainerProps) => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();

    const customer = useSelector(getCustomer);
    const addresses = useSelector(getAddresses, shallowEqual);
    const isLoadingAddressBoek = useSelector(isLoading);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(AddressBookModule.load());
    }, []);

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            {customer && !isLoadingAddressBoek && (
                <ProfileAddresses
                    customer={customer}
                    addresses={addresses}
                    link={linkAddressBook}
                />
            )}
        </Suspense>
    );
};

export { ProfileAddressesContainer };
